// pages/ProjectDashboard.jsx
import React from "react";
import ProjectSiteSummary from "../../components/ProjectSiteSummary/ProjectSiteSummary";

export default function ProjectDashboardPage() {
  return (
    <ProjectSiteSummary
      apiBase="https://jkumarapi.axiomos.in"
    />
  );
}
